import _ from 'lodash'
import React from 'react'
// import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
// import { Button } from 'antd'

const IMAGES = {
  'Card Pay': require('./images/Card Pay.png'),
  payby: require('./images/PayBy Pay.png'),
  'totok-pay': require('./images/ToTok Pay.png'),
  'botim-pay': require('./images/BOTIM Pay.png'),
  38: require('./images/Aani Pay.png'),
  35: require('./images/Apple Pay.png'),
  36: require('./images/Google Pay.svg'),
  37: require('./images/Samsung Pay.png'),
  Balance: require('./images/Balance.png'),
  visa: require('./images/mini/visa.png'),
  mastercard: require('./images/mini/mastercard.png'),
  'Message Pay':require('./images/Message Pay.png'),
  AliPay: require('./images/AliPayDesktopIcon.svg'),
  AliPayPart1: require('./images/ALI.svg'),
  AliPayPart2: require('./images/Ali2.svg'),
}

export default class PaymentMethodIcon extends React.Component {
  // constructor (props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }
  render() {
    const { width, height, tabType, hostApp, payMethod, cardBrand, payChannel } = this.props
    var img = null
    switch (tabType) {
      case 'PAY_METHODS':
        img = IMAGES['Card Pay']
        break
      case 'MESSAGE_PAY':
        img = IMAGES['Message Pay']
        break
      case 'APP':
        img = IMAGES[hostApp]
        break
      case 'MIX_PAY':
        img = IMAGES[38]
        break
      case 'DEVICE_PAY':
        img =
          IMAGES[
            _.get(payMethod, 'payMethodExtension.payChannel') || payChannel
          ]
        break
      case 'WALLET_PAY':
        img = [IMAGES.AliPayPart1, IMAGES.AliPayPart2]
        break
      case 'BALANCE':
        img = IMAGES.BALANCE
        break
      case 'BANK_CARD':
        img = IMAGES[String(cardBrand || '').toLowerCase()] || IMAGES[cardBrand]
        break
      case 'SRC':
        img = this.props.iconUrl
        break
      default:
        break
    }
    return (
      Array.isArray(img) ? (
        <div>
          {img.map((src, index) => <img key={index} width='80px' height={height} src={src} />)}
        </div>
      ) : img ? (
        <img width={width} height={height} src={img} />
      ) : null
    )
  }
}
